export default [
  {
    header: 'База <Фильмы>',
    resource: 'db-movies',
    action: 'view',
  },
  {
    title: 'Фильмы',
    route: 'movies',
    icon: 'FilmIcon',
    tagVariant: 'light-warning',
    resource: 'db-movies',
    action: 'view',
  },
  {
    title: 'Фильмы (old)',
    route: 'movies-old',
    icon: 'FilmIcon',
    tagVariant: 'light-warning',
    resource: 'db-movies',
    action: 'view',
  },
  {
    title: 'Премьеры',
    route: 'movies-premiers',
    icon: 'LoaderIcon',
    tagVariant: 'light-warning',
    resource: 'db-movies',
    action: 'view',
  },
  {
    title: 'Топ фильмов',
    route: 'movies-top',
    icon: 'ArrowUpCircleIcon',
    tagVariant: 'light-warning',
    resource: 'db-movies',
    action: 'view',
  },
  {
    title: 'Фильтр фильмов',
    route: 'movies-filter',
    icon: 'FilterIcon',
    tagVariant: 'light-warning',
    resource: 'db-movies',
    action: 'view',
  },
  {
    title: 'Поиск фильмов',
    route: 'movies-search',
    icon: 'SearchIcon',
    tagVariant: 'light-warning',
    resource: 'db-movies',
    action: 'view',
  },
  {
    title: 'Импорт из Кинопаба',
    route: 'movies-kinopub',
    icon: 'CameraIcon',
    tagVariant: 'light-warning',
    resource: 'db-movies',
    action: 'view',
  },
  {
    title: 'Импорт Коллекций КП',
    route: 'movies-collections',
    icon: 'CameraIcon',
    tagVariant: 'light-warning',
    resource: 'db-movies',
    action: 'view',
  },
]
